// Thin re-export so react-icons v5.5 (typed as ReactNode) plays nice with React 19 JSX types.
import * as Fa from 'react-icons/fa';
import * as Fa6 from 'react-icons/fa6';
import type { JSX } from 'react';

type IconComp = (props: { className?: string; size?: number | string; color?: string; title?: string }) => JSX.Element;

const asIcon = (C: any): IconComp => C as IconComp;

export const FaApple              = asIcon(Fa.FaApple);
export const FaAndroid            = asIcon(Fa.FaAndroid);
export const FaUserPlus           = asIcon(Fa.FaUserPlus);
export const FaStar               = asIcon(Fa.FaStar);
export const FaDollarSign         = asIcon(Fa.FaDollarSign);
export const FaChartLine          = asIcon(Fa.FaChartLine);
export const FaChartBar           = asIcon(Fa.FaChartBar);
export const FaClipboardList      = asIcon(Fa.FaClipboardList);
export const FaLink               = asIcon(Fa.FaLink);
export const FaCreditCard         = asIcon(Fa.FaCreditCard);
export const FaUniversity         = asIcon(Fa.FaUniversity);
export const FaPaypal             = asIcon(Fa.FaPaypal);
export const FaCheckCircle        = asIcon(Fa.FaCheckCircle);
export const FaExclamationTriangle = asIcon(Fa.FaExclamationTriangle);
export const FaRegCalendarAlt     = asIcon(Fa.FaRegCalendarAlt);
export const FaFlask              = asIcon(Fa.FaFlask);
export const FaUndo               = asIcon(Fa.FaUndo);
export const FaArrowUp            = asIcon(Fa.FaArrowUp);
export const FaArrowDown          = asIcon(Fa.FaArrowDown);
export const FaArrowLeft          = asIcon(Fa.FaArrowLeft);
export const FaRocket             = asIcon(Fa.FaRocket);
export const FaLayerGroup         = asIcon(Fa.FaLayerGroup);
export const FaMobileAlt          = asIcon(Fa.FaMobileAlt);

// Tracker icons
export const FaDrumstickBite      = asIcon(Fa.FaDrumstickBite);
export const FaSmile              = asIcon(Fa.FaSmile);
export const FaWeight             = asIcon(Fa.FaWeight);
export const FaBan                = asIcon(Fa.FaBan);
export const FaPlus               = asIcon(Fa.FaPlus);
export const FaStickyNote         = asIcon(Fa.FaStickyNote);
export const FaTint               = asIcon(Fa.FaTint);
export const FaFire               = asIcon(Fa.FaFire);
export const FaTrashAlt           = asIcon(Fa.FaTrashAlt);
export const FaChevronLeft        = asIcon(Fa.FaChevronLeft);
export const FaChevronRight       = asIcon(Fa.FaChevronRight);
export const FaChevronDown        = asIcon(Fa.FaChevronDown);
export const FaGlobe              = asIcon(Fa.FaGlobe);
export const FaEnvelope           = asIcon(Fa.FaEnvelope);
export const FaCalendarDay        = asIcon(Fa.FaCalendarDay);
export const FaBolt               = asIcon(Fa.FaBolt);
export const FaBullseye           = asIcon(Fa.FaBullseye);

// Optional fa6
export const FaEggFried           = asIcon(Fa6.FaEgg);
export const FaButter             = asIcon(Fa6.FaCheese); // closest stand-in for butter/fat

export type IconType = IconComp;
